import { render, staticRenderFns } from "./CopyrightAssignmentTransferApplication.vue?vue&type=template&id=54e3434e&scoped=true&"
import script from "./CopyrightAssignmentTransferApplication.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferApplication.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferApplication.vue?vue&type=style&index=0&id=54e3434e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3434e",
  null
  
)

export default component.exports